import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';

import api from '../../config/api';
import { successLogin } from '../../helpers/notyf';
import Modal from '../../components/reusable/Modals/Modal';
import logo from '../../assets/logo.png';
import apiv2 from '../../config/apiv2';
import { setMe } from '../../features/me/meSlice';

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    passwordConfirmation: '',
    success: false,
    activated: false,
    restorePassword: false,
    message: '',
    remember: false,
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [cookies, setCookies] = useState();

  document.title = ' Airtomic: Log In';

  useEffect(() => {
    const cookies = document.cookie.split(';');
    const array = [];
    cookies.forEach(elem => {
      const element = elem.split('=');
      array.push({
        [element[0]]: element[1],
      });
      setCookies(array);
    });
  }, []);

  //useEffect
  //     window.location.pathname === '/activation' &&
  //       api
  //         .ACTIVATION(window.location.search)
  //         .then(response => this.setState({ activated: response }));

  //     window.location.pathname === '/restore-password' &&
  //       this.setState({ restorePassword: true });

  const handleGoogleLogin = useGoogleLogin({
    scope:
      'openid https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    //flow: 'auth-code',
    onSuccess: response => {
      api
        .GOOGLE_LOGIN({ access_token: response.access_token, payload: cookies })
        .then(response => {
          if (response == 201) {
            apiv2.GET_ME().then(response => {
              dispatch(setMe(response.data));
              if (response.data.has_finished_signup) {
                let {
                  id,
                  email,
                  company: { id: copanyId },
                } = response.data;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'login',
                  user_id: id,
                  company_id: copanyId,
                  email: email,
                });
                navigate('/dashboard', { replace: true });
              } else {
                navigate('/create-account', { replace: true });
              }
            });
          } else {
            setFormData({
              ...formData,
              success: false,
              message: 'Something went wrong, please try again after sometime.',
            });
          }
        });
    },
    onError: () => {
      setFormData({
        ...formData,
        success: false,
        message: 'Something went wrong, please try again after sometime.',
      });
    },
  });

  const handleSubmit = e => {
    e.preventDefault();
    setFormData({ ...formData, message: '', success: false });
    localStorage.setItem('TOKEN_CALL_FROM', 'LOGIN_PAGE');
    return new Promise(r => {
      api
        .LOG_IN(formData)
        .then(loginResponse => {
          if (loginResponse === 200) {
            localStorage.removeItem('TOKEN_CALL_FROM');
            apiv2.GET_ME().then(response => {
              dispatch(setMe(response.data));
              if (response.data.has_finished_signup) {
                let {
                  id,
                  email,
                  company: { id: copanyId },
                } = response.data;
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: 'login',
                  user_id: id,
                  company_id: copanyId,
                  email: email,
                });

                successLogin();
                navigate('/dashboard', { replace: true });
              } else {
                navigate('/create-account', { replace: true });
              }
            });
          } else {
            let message = loginResponse?.detail
              ? loginResponse.detail
              : 'Something went wrong, please try again after sometime.';
            setFormData({ ...formData, success: false, message });
            //failLogin();
          }
        })
        .finally(() => r());
    });
  };

  const handleChange = e =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleCheckbox = e =>
    setFormData({ ...formData, remember: e.target.checked });

  return (
    <main>
      <div className="auth-form-wrapper">
        <img className="logo" alt="Logo" src={logo} />
        <Modal
          type="login"
          data={formData}
          onGoogleLogin={handleGoogleLogin}
          onSubmit={handleSubmit}
          onChange={handleChange}
          onCheckbox={handleCheckbox}
        />
      </div>
    </main>
  );
};

export default LoginPage;

//   handleRestore = e => {
//     e.preventDefault();

//     api
//       .RESET_PASSWORD({ email: this.state.email })
//       .then(
//         message => typeof message === 'string' && this.setState({ message }),
//       );

//     this.setState({ email: '' });
//   };

//   handleNewPassword = e => {
//     const { t } = this.props;
//     e.preventDefault();

//     if (
//       this.state.password === this.state.passwordConfirmation &&
//       this.state.password.length > 5
//     ) {
//       api
//         .NEW_PASSWORD({
//           token: window.location.search,
//           password: this.state.password,
//         })
//         .then(
//           message => typeof message === 'string' && this.setState({ message }),
//         );

//       this.setState({ password: '', passwordConfirmation: '' });
//     } else {
//       notyf.passwordError(t);
//     }
//   };

//     const location = window.location.pathname;

//     return (
//       <>
//         {location === '/password-reset' ? (
//           <form className={css.newPass} onSubmit={this.handleNewPassword}>
//             {message ? (
//               <h3 className={css.subTitle}>{message}</h3>
//             ) : (
//               <>
//                 <h3 className={css.subTitle}>{t('NEW_PASSWORD')}</h3>
//                 <div className={css.flex}>
//                   <input
//                     className={css.input}
//                     id="password"
//                     type="password"
//                     placeholder={t('PASSWORD')}
//                     value={password}
//                     onChange={this.changeHandler}
//                     required
//                   />
//                   <input
//                     className={css.input}
//                     id="passwordConfirmation"
//                     type="password"
//                     placeholder={t('CONFIRM')}
//                     value={passwordConfirmation}
//                     onChange={this.changeHandler}
//                     required
//                   />
//                 </div>
//                 <hr className={css.hrHr} />
//                 <button type="submit" className={css.linkBtn}>
//                   {t('SAVE_PASSWORD')}
//                 </button>
//               </>
//             )}
//           </form>
//         ) : restorePassword ? (
//           <form className={css.restore} onSubmit={this.handleRestore}>
//             {message ? (
//               <h3 className={css.subTitle}>{message}</h3>
//             ) : (
//               <>
//                 <h3 className={css.subTitle}>{t('ENTER_YOUR_EMAIL')}</h3>
//                 <input
//                   className={css.input}
//                   id="email"
//                   type="text"
//                   placeholder={t('YOUR_EMAIL')}
//                   value={email}
//                   onChange={this.changeHandler}
//                   required
//                 />
//                 <hr className={css.hrHr} />
//                 <button type="submit" className={css.linkBtn}>
//                   {t('SEND_LINK')}
//                 </button>
//               </>
//             )}
//           </form>
//         ) : location === '/activation' ? (
//           <div className={css.success}>
//             {activated ? (
//               <>
//                 <h2 className={css.title}>{t('ACTIVATED')}</h2>
//                 <h3 className={css.subTitle}>{t('PLEASE_LOG_IN')}</h3>
//                 <hr className={css.hr} />
//                 <Link to="/login" className={css.homeBtn}>
//                   {t('LOG_IN_BTN')} &gt;
//                 </Link>
//               </>
//             ) : (
//               <>
//                 <h2 className={css.title}>{t('UNFORTUNATELY')}</h2>
//                 <h3 className={css.subTitle}>{t('PLEASE_CONTACT')}</h3>
//                 <hr className={css.hr} />
//                 <Link to="/contacts" className={css.conBtn}>
//                   {t('CONTACT')}
//                 </Link>
//               </>
//             )}
//           </div>
//         ) : success ? (
//           <div className={css.success}>
//             <h2 className={css.title}>{t('THANK_FOR_AUTH')}</h2>
//             <h3 className={css.subTitle}>{t('NOW_U_CAN_USE')}</h3>
//             <hr className={css.hr} />
//             <Link to="/" className={css.homeBtn}>
//               {t('GO_TO_MAIN_PAGE')} &gt;
//             </Link>
//           </div>
//         ) : (login)
